// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b9a65c70","455":"67a0b8fe","977":"042dbb9d"}[chunkId] + ".chunk.js";
};